module.exports = __WEBPACK_EXTERNAL_MODULE__wix_draft_js__;